export default __webpack_public_path__ + "static/media/cocktail pour.b851bb5d.jpg";